<div class="container">
    <table
        mat-table
        [dataSource]="stepStates()"
        class="mat-elevation-z8"
        cdkDropList
        [cdkDropListData]="stepStates()"
        (cdkDropListDropped)="onStateDrop($event)"
        [cdkDropListDisabled]="disabled === true">
        <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef class="drag-column"></th>
            <td mat-cell *matCellDef="let element" class="drag-column">
                <fa-icon cdkDragHandle [ngClass]="{ 'drag-handle': disabled === false }" [icon]="faGripLinesVertical"></fa-icon>
            </td>
        </ng-container>
        <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

        <!-- Colonne 'Nom' -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="column-name">Nom</th>
            <td mat-cell *matCellDef="let element" class="column-name">{{ element.name }}</td>
        </ng-container>

        <!-- Colonne 'Actions' -->
        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="column actions" class="action-column">
                <button mat-icon-button [disabled]="disabled" (click)="onCreateState()" aria-label="Ajouter un état" class="accent-button">
                    <mat-icon>add</mat-icon>
                </button>
            </th>
            <td mat-cell *matCellDef="let element" class="action-column">
                <button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ element: element }" aria-label="Menu contextuel">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            cdkDrag
            cdkDragPreview
            [cdkDragData]="row"
            class="element-row"
            (dblclick)="onMouseDoubleClick(row, $event)"></tr>
    </table>

    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-element="element">
            <button mat-menu-item [disabled]="disabled" (click)="onEditState(element)">
                <mat-icon>edit</mat-icon>
                <span>Editer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDuplicateState(element)">
                <mat-icon>edit</mat-icon>
                <span>Dupliquer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDeleteState(element)">
                <mat-icon>delete</mat-icon>
                <span>Supprimer</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
